import { render, staticRenderFns } from "./ComplaintIndicators.vue?vue&type=template&id=70f2e7d1&scoped=true"
import script from "./ComplaintIndicators.vue?vue&type=script&lang=js"
export * from "./ComplaintIndicators.vue?vue&type=script&lang=js"
import style0 from "./ComplaintIndicators.vue?vue&type=style&index=0&id=70f2e7d1&prod&lang=scss"
import style1 from "./ComplaintIndicators.vue?vue&type=style&index=1&id=70f2e7d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2e7d1",
  null
  
)

export default component.exports